// This file is auto-generated by build-icons-sprite.js
// Do not edit manually

export interface SpriteManifest {
    filename: string;
    hash: string;
}

export const SPRITE_MANIFEST: SpriteManifest = {
    filename: 'icon-sprite.svg',
    hash: 'ccdf0ca1',
};
